import React, { useEffect, useState, useMemo } from "react"
import { get, isEmpty } from "lodash"
import { withRouter } from "react-router"
import { statisticsApiCall } from "components/actions/divisionStatistics"
import { DomesticIndexTemplate } from "components/templates/domestic/indexes"
import { APIResponse } from "redux/apis/types"
import APIs from "redux/apis"
import { getRequestName } from "config/apiConst"
import { EXCHANGE, SECURITY_TYPE } from "config/const"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const DomesticIndex = withRouter(({ location }) => {
  const [indexData, setIndex] = useState<APIResponse.Res | {}>({})
  const [statisticsData, updateStatistics] = useState([])
  const [priceListType, changePriceListType] = useState("Main")
  const [selectData, setSelectData] = useState(0)
  const [detailsData, setDetailsData] = useState<APIResponse.Res>([])
  const loadResistId = useMemo(() => uuid(), [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const requestIndex = async (props: { setData: Function }) => {
    const priceList: APIResponse.Res | {} = await APIs.SymbolDetail.PriceList({
      Name: getRequestName(location.pathname, priceListType),
    })
    props.setData(priceList)
  }

  useEffect(() => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    Promise.all([
      requestIndex({ setData: setIndex }),
      statisticsApiCall({
        updateStatistics: updateStatistics,
        division: "0111,0114,0124,0126",
      }),
    ]).then(() => {
      store.dispatch(pageLoadRegist(loadResistId, false))
    })
  }, [priceListType])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) {
      store.dispatch(pageLoadRegist(loadResistId, true))
      Promise.all([
        requestIndex({ setData: setIndex }),
        statisticsApiCall({
          updateStatistics: updateStatistics,
          division: "0111,0114,0124,0126",
        }),
      ]).then(() => {
        store.dispatch(pageLoadRegist(loadResistId, false))
      })
    }
  }, [isPageLoading])

  useEffect(() => {
    if (isEmpty(indexData) || !isEmpty(location.state) || isNaN(selectData))
      return
    const setData = async () => {
      store.dispatch(pageLoadRegist(loadResistId, true))
      const dataResult = get(indexData, "ResultList")
      const data = dataResult[selectData]
      const symbolDetail = await APIs.SymbolDetail.SymbolDetail({
        Symbol: get(data, "Symbol"),
        Exchange: get(data, "Exchange", EXCHANGE.TSE.id),
        SecurityType: get(data, "SecurityType", SECURITY_TYPE.Equity.id),
      })
      setDetailsData(symbolDetail)
    }
    setData()
    store.dispatch(pageLoadRegist(loadResistId, false))
  }, [indexData, selectData])

  useEffect(() => {
    if (isEmpty(location.state)) return
    const setData = async () => {
      store.dispatch(pageLoadRegist(loadResistId, true))
      const data = get(location.state, "rowData")
      const symbolDetail = await APIs.SymbolDetail.SymbolDetail({
        Symbol: get(data, "Symbol"),
        Exchange: get(data, "Exchange", EXCHANGE.TSE.id),
        SecurityType: get(data, "SecurityType", SECURITY_TYPE.Equity.id),
      })
      location.state = {}
      setDetailsData(symbolDetail)
    }
    setData()
    store.dispatch(pageLoadRegist(loadResistId, false))
  }, [location.state])

  return (
    <DomesticIndexTemplate
      indexData={indexData}
      setIndexData={setIndex}
      statisticsData={statisticsData}
      updateStatistics={updateStatistics}
      changeIndexType={changePriceListType}
      detailsData={detailsData}
      selectData={selectData}
      setSelectData={setSelectData}
      transitionData={get(location.state, "rowData")}
      requestIndex={requestIndex}
    />
  )
})
